/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * iTopFive API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  ITopFiveApiV2EndpointsAuthLoginEndpointParams,
  ITopFiveApiV2EndpointsAuthLogoutEndpointParams,
  ITopFiveApiV2EndpointsAuthMeResponse,
  ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest,
  ITopFiveApiV2EndpointsStaffAddStaffAddStaffResponse,
  ITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdResponse,
  ITopFiveApiV2EndpointsStaffGetStaffListGetStaffListResponse,
  ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest,
  ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffResponse,
  ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest,
  ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveResponse,
  ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest,
  ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentResponse,
  ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest,
  ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesResponse,
  ITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsResponse,
  ITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdResponse,
  ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams,
  ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveResponse,
  ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams,
  ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsResponse,
  ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest,
  ITopFiveApiV2EndpointsTopFiveImportImportTopFiveResponse,
  ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest,
  ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentResponse,
  ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest,
  ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveResponse,
} from './models';

/**
 * Updates TopFive items with authorization checks. Owners can edit status/completion/weight, managers can update results.
 * @summary Update TopFive items
 */
export const iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint = (
  topFiveId: number,
  iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest,
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveResponse>
> => {
  return axios.put(
    `/services/itopfiveapi/topfive/${topFiveId}`,
    iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest,
    options
  );
};

export const getITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint
        >
      >,
      TError,
      {
        topFiveId: number;
        data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint
      >
    >,
    TError,
    {
      topFiveId: number;
      data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint
        >
      >,
      {
        topFiveId: number;
        data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest;
      }
    > = props => {
      const { topFiveId, data } = props ?? {};

      return iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint(
        topFiveId,
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpointMutationBody =
  ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest;
export type ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Update TopFive items
 */
export const useITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint =
  <TError = AxiosError<void>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint
          >
        >,
        TError,
        {
          topFiveId: number;
          data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest;
        },
        TContext
      >;
      axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpoint
      >
    >,
    TError,
    {
      topFiveId: number;
      data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getITopFiveApiV2EndpointsTopFiveUpdateTopFiveUpdateTopFiveEndpointMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };

/**
 * Returns TopFive data for a specific TopFive ID including staff information, TopFive items, and user-specific permissions.
 * @summary Get TopFive data by ID
 */
export const iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint =
  (
    topFiveId: number,
    options?: AxiosRequestConfig
  ): Promise<
    AxiosResponse<ITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdResponse>
  > => {
    return axios.get(`/services/itopfiveapi/topfive/${topFiveId}`, options);
  };

export const getITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpointQueryKey =
  (topFiveId: number) => {
    return [`/services/itopfiveapi/topfive/${topFiveId}`] as const;
  };

export const getITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpointQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
      >
    >,
    TError = AxiosError<void>,
  >(
    topFiveId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
            >
          >,
          TError,
          TData
        >
      >;
      axios?: AxiosRequestConfig;
    }
  ) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpointQueryKey(
        topFiveId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
        >
      >
    > = ({ signal }) =>
      iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint(
        topFiveId,
        { signal, ...axiosOptions }
      );

    return {
      queryKey,
      queryFn,
      enabled: !!topFiveId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpointQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  topFiveId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  topFiveId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  topFiveId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get TopFive data by ID
 */

export function useITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  topFiveId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsTopFiveGetTopFiveByIdGetTopFiveByIdEndpointQueryOptions(
      topFiveId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a TopFive item comment. Only the comment author can update their comment.
 * @summary Update TopFive item comment
 */
export const iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint =
  (
    topFiveItemId: number,
    commentId: number,
    iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest,
    options?: AxiosRequestConfig
  ): Promise<
    AxiosResponse<ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentResponse>
  > => {
    return axios.put(
      `/services/itopfiveapi/topfive/items/${topFiveItemId}/comments/${commentId}`,
      iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest,
      options
    );
  };

export const getITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint
        >
      >,
      TError,
      {
        topFiveItemId: number;
        commentId: number;
        data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint
      >
    >,
    TError,
    {
      topFiveItemId: number;
      commentId: number;
      data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint
        >
      >,
      {
        topFiveItemId: number;
        commentId: number;
        data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest;
      }
    > = props => {
      const { topFiveItemId, commentId, data } = props ?? {};

      return iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint(
        topFiveItemId,
        commentId,
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpointMutationBody =
  ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest;
export type ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Update TopFive item comment
 */
export const useITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint =
  <TError = AxiosError<void>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint
          >
        >,
        TError,
        {
          topFiveItemId: number;
          commentId: number;
          data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest;
        },
        TContext
      >;
      axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpoint
      >
    >,
    TError,
    {
      topFiveItemId: number;
      commentId: number;
      data: ITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getITopFiveApiV2EndpointsTopFiveUpdateTopFiveItemCommentUpdateTopFiveItemCommentEndpointMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };

/**
 * Soft deletes a TopFive item comment. Only the comment author can delete their comment.
 * @summary Delete TopFive item comment
 */
export const iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint =
  (
    topFiveItemId: number,
    commentId: number,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/services/itopfiveapi/topfive/items/${topFiveItemId}/comments/${commentId}`,
      options
    );
  };

export const getITopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint
        >
      >,
      TError,
      { topFiveItemId: number; commentId: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint
      >
    >,
    TError,
    { topFiveItemId: number; commentId: number },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint
        >
      >,
      { topFiveItemId: number; commentId: number }
    > = props => {
      const { topFiveItemId, commentId } = props ?? {};

      return iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint(
        topFiveItemId,
        commentId,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint
      >
    >
  >;

export type ITopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Delete TopFive item comment
 */
export const useITopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint =
  <TError = AxiosError<void>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint
          >
        >,
        TError,
        { topFiveItemId: number; commentId: number },
        TContext
      >;
      axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpoint
      >
    >,
    TError,
    { topFiveItemId: number; commentId: number },
    TContext
  > => {
    const mutationOptions =
      getITopFiveApiV2EndpointsTopFiveDeleteTopFiveItemCommentDeleteTopFiveItemCommentEndpointMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };

/**
 * Imports TopFive data from a CSV file. Expected columns:
- FirstName: Staff first name
- Surname: Staff surname  
- Name: TopFive goal name
- Weight: Priority weight (1-10)
- Third: Quarter/third (1-5, optional)
- EmployeeId: Staff employee ID

File size limit: 5MB
Supported format: CSV (.csv)
 * @summary Import TopFive data from CSV file
 */
export const iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint = (
  iTopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest: ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest,
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsTopFiveImportImportTopFiveResponse>
> => {
  const formData = new FormData();
  formData.append(
    `file`,
    iTopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest.file
  );
  formData.append(
    `startDate`,
    iTopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest.startDate
  );
  formData.append(
    `endDate`,
    iTopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest.endDate
  );

  return axios.post(`/services/itopfiveapi/topfive/import`, formData, options);
};

export const getITopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint
        >
      >,
      TError,
      { data: ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint
      >
    >,
    TError,
    { data: ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint
        >
      >,
      { data: ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest }
    > = props => {
      const { data } = props ?? {};

      return iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint(
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpointMutationBody =
  ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest;
export type ITopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Import TopFive data from CSV file
 */
export const useITopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint = <
  TError = AxiosError<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint
        >
      >,
      TError,
      { data: ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpoint>
  >,
  TError,
  { data: ITopFiveApiV2EndpointsTopFiveImportImportTopFiveRequest },
  TContext
> => {
  const mutationOptions =
    getITopFiveApiV2EndpointsTopFiveImportImportTopFiveEndpointMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns TopFive data based on search criteria. Supports Name search (staff names), TopFive search (TopFive item names), and StaffId query. If StaffId is provided, returns all current and previous TopFives for that staff without cadence filtering. If no search text or StaffId provided, returns current user data.
 * @summary Get TopFive data with search functionality
 */
export const iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint = (
  params?: ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams,
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveResponse>
> => {
  return axios.get(`/services/itopfiveapi/topfive`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointQueryKey =
  (
    params?: ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams
  ) => {
    return [
      `/services/itopfiveapi/topfive`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
      >
    >,
    TError = AxiosError<void>,
  >(
    params?: ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
            >
          >,
          TError,
          TData
        >
      >;
      axios?: AxiosRequestConfig;
    }
  ) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
        >
      >
    > = ({ signal }) =>
      iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint(params, {
        signal,
        ...axiosOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint>
  >,
  TError = AxiosError<void>,
>(
  params:
    | undefined
    | ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint>
  >,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint>
  >,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get TopFive data with search functionality
 */

export function useITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint>
  >,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsTopFiveGetTopFiveGetTopFiveEndpointQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns TopFive item suggestions based on search text. Requires at least 3 characters. Only returns items from current and previous periods.
 * @summary Get TopFive item name suggestions
 */
export const iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint =
  (
    params: ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams,
    options?: AxiosRequestConfig
  ): Promise<
    AxiosResponse<ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsResponse>
  > => {
    return axios.get(`/services/itopfiveapi/topfive/item-suggestions`, {
      ...options,
      params: { ...params, ...options?.params },
    });
  };

export const getITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointQueryKey =
  (
    params: ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams
  ) => {
    return [
      `/services/itopfiveapi/topfive/item-suggestions`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
      >
    >,
    TError = AxiosError<void>,
  >(
    params: ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
            >
          >,
          TError,
          TData
        >
      >;
      axios?: AxiosRequestConfig;
    }
  ) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
        >
      >
    > = ({ signal }) =>
      iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint(
        params,
        { signal, ...axiosOptions }
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  params: ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  params: ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  params: ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get TopFive item name suggestions
 */

export function useITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  params: ITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsTopFiveGetTopFiveItemSuggestionsGetTopFiveItemSuggestionsEndpointQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all available period options for TopFive import. Includes current and previous periods for Thirds, Half, and Global cadence types. Periods are calculated based on InfoTrack financial year (July-June).
 * @summary Get available TopFive cadence periods
 */
export const iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint = (
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsResponse>
> => {
  return axios.get(`/services/itopfiveapi/topfive/periods`, options);
};

export const getITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpointQueryKey =
  () => {
    return [`/services/itopfiveapi/topfive/periods`] as const;
  };

export const getITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpointQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
      >
    >,
    TError = AxiosError<void>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  }) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpointQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
        >
      >
    > = ({ signal }) =>
      iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint({
        signal,
        ...axiosOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpointQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get available TopFive cadence periods
 */

export function useITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpointQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Calculates TopFive bonuses based on CSV data and distributes amounts across TopFive items. 
Expected CSV columns:
- FirstName: Staff first name
- Surname: Staff surname
- EmployeeId: Staff employee ID
- Amount: Total bonus amount to distribute

The endpoint will:
1. Match staff members to their TopFives within the specified date range
2. Distribute bonus amounts across TopFive items based on weights
3. Apply bonuses only to items with 'Pass' status
4. Return detailed breakdown for each staff member's TopFive items

File size limit: 5MB
Supported format: CSV (.csv)
Requires: calculateTopFiveBonusesSecurityUser permission
 * @summary Calculate TopFive bonuses from CSV file
 */
export const iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint =
  (
    iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest: ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest,
    options?: AxiosRequestConfig
  ): Promise<
    AxiosResponse<ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesResponse>
  > => {
    const formData = new FormData();
    formData.append(
      `file`,
      iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest.file
    );
    formData.append(
      `startDate`,
      iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest.startDate
    );
    formData.append(
      `endDate`,
      iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest.endDate
    );

    return axios.post(
      `/services/itopfiveapi/topfive/calculate-bonuses`,
      formData,
      options
    );
  };

export const getITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint
        >
      >,
      TError,
      {
        data: ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint
      >
    >,
    TError,
    {
      data: ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint
        >
      >,
      {
        data: ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest;
      }
    > = props => {
      const { data } = props ?? {};

      return iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint(
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpointMutationBody =
  ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest;
export type ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Calculate TopFive bonuses from CSV file
 */
export const useITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint =
  <TError = AxiosError<void>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint
          >
        >,
        TError,
        {
          data: ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest;
        },
        TContext
      >;
      axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpoint
      >
    >,
    TError,
    {
      data: ITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getITopFiveApiV2EndpointsTopFiveCalculateBonusesCalculateBonusesEndpointMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };

/**
 * Adds a new comment to a TopFive item. Any authenticated user can add comments.
 * @summary Add comment to TopFive item
 */
export const iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint =
  (
    topFiveItemId: number,
    iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest: ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest,
    options?: AxiosRequestConfig
  ): Promise<
    AxiosResponse<ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentResponse>
  > => {
    return axios.post(
      `/services/itopfiveapi/topfive/items/${topFiveItemId}/comments`,
      iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest,
      options
    );
  };

export const getITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint
        >
      >,
      TError,
      {
        topFiveItemId: number;
        data: ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint
      >
    >,
    TError,
    {
      topFiveItemId: number;
      data: ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint
        >
      >,
      {
        topFiveItemId: number;
        data: ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest;
      }
    > = props => {
      const { topFiveItemId, data } = props ?? {};

      return iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint(
        topFiveItemId,
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpointMutationBody =
  ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest;
export type ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Add comment to TopFive item
 */
export const useITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint =
  <TError = AxiosError<void>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint
          >
        >,
        TError,
        {
          topFiveItemId: number;
          data: ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest;
        },
        TContext
      >;
      axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpoint
      >
    >,
    TError,
    {
      topFiveItemId: number;
      data: ITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getITopFiveApiV2EndpointsTopFiveAddTopFiveItemCommentAddTopFiveItemCommentEndpointMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };

/**
 * Creates a new TopFive record or updates an existing one for the specified staff member and date range.

Authorization Requirements:
- User must have 'addTopFiveSecurityUser' permission, be in HR, or be a manager (non-US only)
- Without explicit permission: Can only add/update for direct/indirect subordinates

Behavior:
- If TopFive exists for staff + date range: Updates/adds items
- If TopFive doesn't exist: Creates new TopFive
- Items with TopFiveItemId are updated; items without are created

Request Body:
- StaffId: Target staff member ID
- StartDate: TopFive period start date
- EndDate: TopFive period end date  
- Items: 1-5 TopFive goals with name, weight, and optional status/completion
 * @summary Add or update TopFive for a specific staff member
 */
export const iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint =
  (
    staffId: number,
    iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest: ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest,
    options?: AxiosRequestConfig
  ): Promise<
    AxiosResponse<ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveResponse>
  > => {
    return axios.post(
      `/services/itopfiveapi/topfive/staff/${staffId}`,
      iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest,
      options
    );
  };

export const getITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint
        >
      >,
      TError,
      {
        staffId: number;
        data: ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint
      >
    >,
    TError,
    {
      staffId: number;
      data: ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint
        >
      >,
      {
        staffId: number;
        data: ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest;
      }
    > = props => {
      const { staffId, data } = props ?? {};

      return iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint(
        staffId,
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpointMutationBody =
  ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest;
export type ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Add or update TopFive for a specific staff member
 */
export const useITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint =
  <TError = AxiosError<void>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint
          >
        >,
        TError,
        {
          staffId: number;
          data: ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest;
        },
        TContext
      >;
      axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpoint
      >
    >,
    TError,
    {
      staffId: number;
      data: ITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getITopFiveApiV2EndpointsTopFiveAddOrUpdateTopFiveAddOrUpdateTopFiveEndpointMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };

/**
 * Updates an existing staff member with the provided details. Requires iNominate admin or TopFive staff editor access.
 * @summary Update an existing staff member
 */
export const iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint = (
  id: number,
  iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest: ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest,
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffResponse>
> => {
  return axios.put(
    `/services/itopfiveapi/staff/${id}`,
    iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest,
    options
  );
};

export const getITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint
        >
      >,
      TError,
      {
        id: number;
        data: ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint
      >
    >,
    TError,
    {
      id: number;
      data: ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint',
    ];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint
        >
      >,
      {
        id: number;
        data: ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest;
      }
    > = props => {
      const { id, data } = props ?? {};

      return iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint(
        id,
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpointMutationBody =
  ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest;
export type ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Update an existing staff member
 */
export const useITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint = <
  TError = AxiosError<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint
        >
      >,
      TError,
      {
        id: number;
        data: ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpoint>
  >,
  TError,
  {
    id: number;
    data: ITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffRequest;
  },
  TContext
> => {
  const mutationOptions =
    getITopFiveApiV2EndpointsStaffUpdateStaffUpdateStaffEndpointMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * Retrieves a specific staff member by their ID. Returns permission flags indicating whether the current user has iNominate admin or TopFive staff editor access.
 * @summary Get staff member by ID
 */
export const iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint = (
  id: number,
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdResponse>
> => {
  return axios.get(`/services/itopfiveapi/staff/${id}`, options);
};

export const getITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpointQueryKey =
  (id: number) => {
    return [`/services/itopfiveapi/staff/${id}`] as const;
  };

export const getITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpointQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
      >
    >,
    TError = AxiosError<void>,
  >(
    id: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
            >
          >,
          TError,
          TData
        >
      >;
      axios?: AxiosRequestConfig;
    }
  ) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpointQueryKey(
        id
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
        >
      >
    > = ({ signal }) =>
      iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint(id, {
        signal,
        ...axiosOptions,
      });

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpointQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get staff member by ID
 */

export function useITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsStaffGetStaffByIdGetStaffByIdEndpointQueryOptions(
      id,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves all staff members with their details. Returns permission flags indicating whether the current user has iNominate admin or TopFive staff editor access.
 * @summary Get list of all staff members
 */
export const iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint = (
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsStaffGetStaffListGetStaffListResponse>
> => {
  return axios.get(`/services/itopfiveapi/staff`, options);
};

export const getITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpointQueryKey =
  () => {
    return [`/services/itopfiveapi/staff`] as const;
  };

export const getITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpointQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
      >
    >,
    TError = AxiosError<void>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  }) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpointQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
        >
      >
    > = ({ signal }) =>
      iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint({
        signal,
        ...axiosOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpointQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
      >
    >
  >;
export type ITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
            >
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get list of all staff members
 */

export function useITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint<
  TData = Awaited<
    ReturnType<
      typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
    >
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof iTopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpoint
          >
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsStaffGetStaffListGetStaffListEndpointQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new staff member with the provided details. Requires iNominate admin or TopFive staff editor access.
 * @summary Add a new staff member
 */
export const iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint = (
  iTopFiveApiV2EndpointsStaffAddStaffAddStaffRequest: ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest,
  options?: AxiosRequestConfig
): Promise<
  AxiosResponse<ITopFiveApiV2EndpointsStaffAddStaffAddStaffResponse>
> => {
  return axios.post(
    `/services/itopfiveapi/staff`,
    iTopFiveApiV2EndpointsStaffAddStaffAddStaffRequest,
    options
  );
};

export const getITopFiveApiV2EndpointsStaffAddStaffAddStaffEndpointMutationOptions =
  <TError = AxiosError<void>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint>
      >,
      TError,
      { data: ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint>
    >,
    TError,
    { data: ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest },
    TContext
  > => {
    const mutationKey = ['iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint'];
    const { mutation: mutationOptions, axios: axiosOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint>
      >,
      { data: ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest }
    > = props => {
      const { data } = props ?? {};

      return iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint(
        data,
        axiosOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ITopFiveApiV2EndpointsStaffAddStaffAddStaffEndpointMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint>
    >
  >;
export type ITopFiveApiV2EndpointsStaffAddStaffAddStaffEndpointMutationBody =
  ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest;
export type ITopFiveApiV2EndpointsStaffAddStaffAddStaffEndpointMutationError =
  AxiosError<void>;

/**
 * @summary Add a new staff member
 */
export const useITopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint = <
  TError = AxiosError<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint>
      >,
      TError,
      { data: ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsStaffAddStaffAddStaffEndpoint>
  >,
  TError,
  { data: ITopFiveApiV2EndpointsStaffAddStaffAddStaffRequest },
  TContext
> => {
  const mutationOptions =
    getITopFiveApiV2EndpointsStaffAddStaffAddStaffEndpointMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns 'pong'
 * @summary Ping endpoint
 */
export const iTopFiveApiV2EndpointsPingPingEndpoint = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<string>> => {
  return axios.get(`/services/itopfiveapi/ping`, options);
};

export const getITopFiveApiV2EndpointsPingPingEndpointQueryKey = () => {
  return [`/services/itopfiveapi/ping`] as const;
};

export const getITopFiveApiV2EndpointsPingPingEndpointQueryOptions = <
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getITopFiveApiV2EndpointsPingPingEndpointQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>
  > = ({ signal }) =>
    iTopFiveApiV2EndpointsPingPingEndpoint({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ITopFiveApiV2EndpointsPingPingEndpointQueryResult = NonNullable<
  Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>
>;
export type ITopFiveApiV2EndpointsPingPingEndpointQueryError =
  AxiosError<unknown>;

export function useITopFiveApiV2EndpointsPingPingEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
  TError = AxiosError<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsPingPingEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsPingPingEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Ping endpoint
 */

export function useITopFiveApiV2EndpointsPingPingEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
  TError = AxiosError<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsPingPingEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsPingPingEndpointQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns success only if the current user has the TopFive.Admin role
 * @summary App role check
 */
export const iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(`/services/itopfiveapi/auth/app_role_check`, options);
};

export const getITopFiveApiV2EndpointsAuthAppRoleCheckEndpointQueryKey = () => {
  return [`/services/itopfiveapi/auth/app_role_check`] as const;
};

export const getITopFiveApiV2EndpointsAuthAppRoleCheckEndpointQueryOptions = <
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
  >,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
      >,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getITopFiveApiV2EndpointsAuthAppRoleCheckEndpointQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>>
  > = ({ signal }) =>
    iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ITopFiveApiV2EndpointsAuthAppRoleCheckEndpointQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>>
  >;
export type ITopFiveApiV2EndpointsAuthAppRoleCheckEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsAuthAppRoleCheckEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
          >,
          TError,
          Awaited<
            ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthAppRoleCheckEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
          >,
          TError,
          Awaited<
            ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthAppRoleCheckEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary App role check
 */

export function useITopFiveApiV2EndpointsAuthAppRoleCheckEndpoint<
  TData = Awaited<
    ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
  >,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof iTopFiveApiV2EndpointsAuthAppRoleCheckEndpoint>
        >,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsAuthAppRoleCheckEndpointQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Initiates OIDC authentication flow or redirects if already authenticated.
 * @summary Initiate user login
 */
export const iTopFiveApiV2EndpointsAuthLoginEndpoint = (
  params?: ITopFiveApiV2EndpointsAuthLoginEndpointParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(`/services/itopfiveapi/auth/login`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getITopFiveApiV2EndpointsAuthLoginEndpointQueryKey = (
  params?: ITopFiveApiV2EndpointsAuthLoginEndpointParams
) => {
  return [
    `/services/itopfiveapi/auth/login`,
    ...(params ? [params] : []),
  ] as const;
};

export const getITopFiveApiV2EndpointsAuthLoginEndpointQueryOptions = <
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLoginEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  }
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getITopFiveApiV2EndpointsAuthLoginEndpointQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>
  > = ({ signal }) =>
    iTopFiveApiV2EndpointsAuthLoginEndpoint(params, {
      signal,
      ...axiosOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ITopFiveApiV2EndpointsAuthLoginEndpointQueryResult = NonNullable<
  Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>
>;
export type ITopFiveApiV2EndpointsAuthLoginEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsAuthLoginEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
  TError = AxiosError<void>,
>(
  params: undefined | ITopFiveApiV2EndpointsAuthLoginEndpointParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthLoginEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLoginEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthLoginEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLoginEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Initiate user login
 */

export function useITopFiveApiV2EndpointsAuthLoginEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLoginEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLoginEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getITopFiveApiV2EndpointsAuthLoginEndpointQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Signs out the user from both cookie and OIDC authentication schemes.
 * @summary Sign out user
 */
export const iTopFiveApiV2EndpointsAuthLogoutEndpoint = (
  params?: ITopFiveApiV2EndpointsAuthLogoutEndpointParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(`/services/itopfiveapi/auth/logout`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getITopFiveApiV2EndpointsAuthLogoutEndpointQueryKey = (
  params?: ITopFiveApiV2EndpointsAuthLogoutEndpointParams
) => {
  return [
    `/services/itopfiveapi/auth/logout`,
    ...(params ? [params] : []),
  ] as const;
};

export const getITopFiveApiV2EndpointsAuthLogoutEndpointQueryOptions = <
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLogoutEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  }
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getITopFiveApiV2EndpointsAuthLogoutEndpointQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>
  > = ({ signal }) =>
    iTopFiveApiV2EndpointsAuthLogoutEndpoint(params, {
      signal,
      ...axiosOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ITopFiveApiV2EndpointsAuthLogoutEndpointQueryResult = NonNullable<
  Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>
>;
export type ITopFiveApiV2EndpointsAuthLogoutEndpointQueryError =
  AxiosError<void>;

export function useITopFiveApiV2EndpointsAuthLogoutEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
  TError = AxiosError<void>,
>(
  params: undefined | ITopFiveApiV2EndpointsAuthLogoutEndpointParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthLogoutEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLogoutEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthLogoutEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLogoutEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Sign out user
 */

export function useITopFiveApiV2EndpointsAuthLogoutEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
  TError = AxiosError<void>,
>(
  params?: ITopFiveApiV2EndpointsAuthLogoutEndpointParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthLogoutEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getITopFiveApiV2EndpointsAuthLogoutEndpointQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns current authentication status, profile fields and (optionally) the user's profile photo.
 * @summary Current user info
 */
export const iTopFiveApiV2EndpointsAuthMeEndpoint = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ITopFiveApiV2EndpointsAuthMeResponse>> => {
  return axios.get(`/services/itopfiveapi/auth/me`, options);
};

export const getITopFiveApiV2EndpointsAuthMeEndpointQueryKey = () => {
  return [`/services/itopfiveapi/auth/me`] as const;
};

export const getITopFiveApiV2EndpointsAuthMeEndpointQueryOptions = <
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getITopFiveApiV2EndpointsAuthMeEndpointQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>
  > = ({ signal }) =>
    iTopFiveApiV2EndpointsAuthMeEndpoint({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ITopFiveApiV2EndpointsAuthMeEndpointQueryResult = NonNullable<
  Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>
>;
export type ITopFiveApiV2EndpointsAuthMeEndpointQueryError = AxiosError<void>;

export function useITopFiveApiV2EndpointsAuthMeEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
  TError = AxiosError<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthMeEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
          TError,
          Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useITopFiveApiV2EndpointsAuthMeEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Current user info
 */

export function useITopFiveApiV2EndpointsAuthMeEndpoint<
  TData = Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
  TError = AxiosError<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof iTopFiveApiV2EndpointsAuthMeEndpoint>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getITopFiveApiV2EndpointsAuthMeEndpointQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
